import { render } from "./amountBreakupSq.vue?vue&type=template&id=89371076"
import script from "./amountBreakupSq.vue?vue&type=script&lang=js"
export * from "./amountBreakupSq.vue?vue&type=script&lang=js"

import "./amountBreakupSq.vue?vue&type=style&index=0&id=89371076&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__